import React from 'react';
import SettingsContainer, { SettingsSettingType } from '../../../components/settings/SettingsContainer';

const InvoiceSettings: React.FC = () => {
    const settings: SettingsSettingType[] = [
        {
            title: 'invoice.settings.numbering_scheme_title',
            explanationText: 'invoice.settings.numbering_scheme_explanation',
            fields: [
                {
                    type: 'text',
                    label: 'settings.general.number_sequence_title',
                    name: 'invoice_numbering_scheme',
                    placeholder: '',
                    group: 'field-row',
                    width: '30%',
                    shouldAutoFocus: false
                },
                {
                    type: 'number',
                    label: 'settings.general.next_number_label',
                    name: 'invoice_current_number',
                    group: 'field-row',
                    width: '30%'
                }
            ]
        },
        {
            title: 'invoice.settings.show_tax_blocked_account_title',
            scope: 'division',
            explanationText: 'invoice.settings.show_tax_blocked_account_explanation',
            switchButton: {
                enabled: true,
                name: 'invoice_show_tax_blocked_acount',
            }
        },
    ];

    return (
        <SettingsContainer settings={settings} />
    );
};

export default InvoiceSettings;